export default (state, includeDeleted) => {
  state.includeDeletedGuestlists = includeDeleted;
}



// WEBPACK FOOTER //
// ./src/app/store/rsvps/mutations/set-included-deleted-guestlists.js